// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Gg0u","col":"styles_col__3q9se"};